function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3487 16.6709C21.0994 53.4304 16.7969 90.7288 22.8522 127.533C27.739 157.152 40.0622 186.299 62.212 209.899C74.1103 222.609 88.8503 233.298 105.848 240.843C107.441 241.562 112.753 239.563 110.469 238.53C80.1391 225.057 58.122 201.456 44.5771 175.228C28.7482 144.554 24.8441 110.781 25.8268 77.6148C26.3845 57.0457 28.7482 36.5215 31.1119 16.0197C31.3244 14.1559 25.5346 15.0766 25.3487 16.6709Z",
  fill: "#121212"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7384 23.8344C22.5086 21.8808 23.4116 19.9945 24.5271 18.1981C25.0582 17.3448 25.616 16.5139 26.2268 15.7056C26.8111 14.9421 27.4751 14.3133 28.1125 13.5947C28.2984 13.4151 24.4474 13.5723 25.3238 14.1561C25.5628 14.2909 25.7488 14.4031 25.9612 14.5828C26.333 14.8972 26.6517 15.234 26.997 15.5708C27.8734 16.4241 28.7499 17.2774 29.6263 18.1307C31.3792 19.8373 33.132 21.544 34.8849 23.273C35.1505 23.52 36.08 23.4976 36.3722 23.4751C37.1158 23.4302 37.9126 23.273 38.6297 23.0485C39.1874 22.8688 41.0199 22.2401 40.3294 21.5664C38.1516 19.4556 36.0004 17.3448 33.8491 15.2564C32.9461 14.3807 32.0963 13.2579 30.9808 12.5618C29.4404 11.6411 27.2095 12.0004 25.5628 12.5169C22.6414 13.4376 21.101 15.6157 19.6137 17.7939C18.153 19.9721 16.9579 22.2625 16.0283 24.6428C15.6831 25.5186 17.914 25.294 18.392 25.2266C19.1357 25.1144 19.9059 24.9347 20.5964 24.6428C20.9682 24.4632 21.6056 24.2161 21.7384 23.8344Z",
  fill: "#121212"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 119,
  height: 253,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 95,
  height: 229,
  fill: "white",
  transform: "translate(16 12)"
})));

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 253,
    viewBox: "0 0 119 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.fdc931ab.svg";
export { ForwardRef as ReactComponent };